<script lang="ts">
    
    import { screenOrientationService } from "../../Services";

    const screenAngle = $screenOrientationService;

    let angle = 0;

    if (screenAngle == 90) {
        angle = -90;
    } else if (screenAngle == 270) {
        angle = 90;
    }

</script>

<div class="orientation-warn" style="--angle: {angle}deg;">
    <img class="smartphone" src="/images/smartphone.svg" alt="">
</div>

<style lang="scss">

    .orientation-warn {
        position: fixed;
        z-index: 999;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: hidden;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .smartphone {
        height: 70vmin;
        transform: rotate(var(--angle));
        animation-name: rotate-smartphone;
        animation-duration: 1s;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        animation-delay: 1s;
    }

    @keyframes rotate-smartphone {
        0% {
            transform: rotate(var(--angle));
        }
        100% {
            transform: rotate(0deg);
        }
    }

</style>
